import React from 'react';

import { Link, Tooltip } from '@mui/material';

type Props = {
  url: string;
  children: React.ReactNode;
};

export class KibanaLink extends React.Component<Props> {
  render() {
    return (
      <Tooltip title="Open request in Kibana in a new tab">
        <Link href={this.props.url} target="_blank">
          {this.props.children}
        </Link>
      </Tooltip>
    );
  }
}
